type Transaction = {
  fullDate: Date;
  year: number;
  month: number;
  date: number;
  desc: string;
  bank: string;
  amount: number;
  category: string;
  BCJL: string;
  createdAt: Date;
};

type FileLoaded = {
  file: {
    name: string;
  };
  createdAt: Date;
};

type Sum = {
  subject: string;
  total: number;
};

type Summary = {
  category: Selection;
  BCJL: Selection;
  bank: Selection;
};
class Selection {
  unique: string[];
  selected: boolean[];
  sum: Sum[];
  constructor(unique: string[], selected: boolean[], sum: Sum[]) {
    this.unique = unique;
    this.selected = selected;
    this.sum = sum;
  }
}

export { Transaction, FileLoaded, Sum, Summary, Selection };
